import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { IonItem } from '@ionic/angular/standalone';

@Component({
    selector: 'lib-input-wrapper',
    standalone: true,
    imports: [CommonModule, IonItem],
    templateUrl: './input-wrapper.component.html',
    styleUrl: './input-wrapper.component.css'
})
export class InputWrapperComponent {
    @Input() ionItemWrap: boolean = true;
    @Input() addBottomMargin: boolean = true;
    @Input() disabled: boolean = false;
}
